/* Product page: gallery, size picker driven by the live Shopify variants (JSON from Liquid), sticky buy bar.
   The form itself is a native POST to /cart/add, so it works before this script loads. */
(() => {
  const BULK = "/pages/bulk";
  const NOTE = {
    tote: `Checkout shows a $500 freight estimate. We quote the exact LTL rate for your ZIP before it ships. You'll need a dock, a forklift or a liftgate: about 2,400 lb arrives on a pallet. <a href="${BULK}">Bulk details</a>.`,
    amazon: "The 32 oz is sold out at the farm right now. It's the same concentrate on Amazon, or the 128 oz here works out at less than half the cost per ounce.",
    out: "This size is sold out right now. Email support@farmmadeorganics.com and we'll tell you when it's back.",
  };
  let V = {};
  try { V = JSON.parse(document.querySelector("[data-variants]").textContent); } catch (e) { /* form still posts natively */ }

  /* gallery */
  const main = document.querySelector("[data-main]");
  const thumbs = [...document.querySelectorAll(".gallery__thumbs button")];
  const show = (src, alt) => { main.src = src; main.alt = alt; thumbs.forEach((t) => t.setAttribute("aria-pressed", String(t.dataset.src === src))); };
  thumbs.forEach((t) => t.addEventListener("click", () => show(t.dataset.src, t.dataset.alt)));

  /* size + quantity */
  const form = document.querySelector("[data-buy]");
  if (!form) return;
  const cta = form.querySelector("[data-cta]");
  const amz = form.querySelector("[data-amazon]");
  const row = form.querySelector("[data-qtyrow]");
  const qty = form.querySelector("[data-qty]");
  const note = form.querySelector("[data-note]");
  const bar = document.querySelector("[data-buybar]");
  /* Subscribe and save: the plan <select> is the selling_plan field, enabled only when "Subscribe" is chosen */
  const plans = form.querySelector("[data-plans]");
  const planSel = form.querySelector("[data-plan-select]");
  const planFreq = form.querySelector("[data-plan-freq]");
  const subOn = () => !!(plans && !plans.hidden && form.querySelector("input[name=purchase]:checked")?.value === "sub");
  const clamp = (n, max) => Math.max(1, Math.min(max || 99, Math.round(n) || 1));
  const update = (moveGallery = true) => {
    const input = form.querySelector("input[name=id]:checked");
    if (!input) return;
    const v = V[input.value] || { key: input.dataset.key, available: true, max: 24 };
    if (v.amazon) {
      row.dataset.mode = "amazon";
      cta.hidden = true; amz.hidden = false;
      note.hidden = false; note.textContent = NOTE.amazon;
    } else {
      row.dataset.mode = "";
      cta.hidden = false; amz.hidden = true;
      qty.value = clamp(qty.value, v.max);
      cta.disabled = !v.available;
      cta.textContent = v.available ? "Add to cart" : "Sold out";
      const n = !v.available ? NOTE.out : NOTE[v.key];
      note.hidden = !n; note.innerHTML = n || "";
    }
    let price = v.price;
    if (plans) {
      const planIds = Object.keys(v.plans || {});
      plans.hidden = !planIds.length || !v.available || !!v.amazon;
      if (!plans.hidden) {
        form.querySelector("[data-once-price]").textContent = v.price;
        if (!v.plans[planSel.value]) planSel.value = planIds[0];
        form.querySelector("[data-sub-price]").textContent = v.plans[planSel.value];
      }
      const on = subOn();
      planSel.disabled = !on; planFreq.hidden = !on;
      if (on) price = `${v.plans[planSel.value]} subscribed`;
    }
    if (bar && v.name) { bar.querySelector("b").textContent = v.name; bar.querySelector("span").textContent = `${price} · ${v.amazon ? "On Amazon" : "Free shipping"}`; }
    thumbs.forEach((b) => { if (b.dataset.only) b.hidden = b.dataset.only !== v.key; });
    if (moveGallery && v.img) show(v.img, v.name);
  };
  form.addEventListener("change", (e) => {
    if (e.target.name === "purchase" || e.target.name === "selling_plan") { update(false); return; }
    if (e.target.name !== "id") return;
    update();
    const url = new URL(location.href); url.searchParams.set("variant", e.target.value);
    history.replaceState(null, "", url);
  });
  form.querySelectorAll("[data-step]").forEach((b) => b.addEventListener("click", () => { qty.value = (+qty.value || 1) + +b.dataset.step; update(false); }));
  qty.addEventListener("change", () => update(false));
  update();

  /* sticky buy bar once the buy box is off screen */
  const buy = document.getElementById("buy");
  if (bar && buy && "IntersectionObserver" in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle("is-on", on); bar.setAttribute("aria-hidden", String(!on));
      bar.querySelector("a").tabIndex = on ? 0 : -1;
    }).observe(buy);
  }
})();
